window.Convermax.handleProductCompareClick = () => {
  const productsIdsToCompare = [...window.document.querySelectorAll('input[name="products[]"]:checked')].map(
    (product) => product.dataset.compareId,
  );
  const compareBtn = window.document.body.querySelector('.cm_compare-btn');
  if (!compareBtn) {
    return;
  }

  compareBtn.classList.toggle('disabled', productsIdsToCompare.length < 2);
  compareBtn.querySelector('a').href = `/compare/${productsIdsToCompare.join('/')}/`;
};

function responseHandler({ Facets, ...rest }) {
  const filteredFacets = window.Convermax.BigCommerce?.isLoggedIn
    ? Facets
    : Facets.filter((f) => f.FieldName !== 'price');
  return { Facets: filteredFacets, ...rest };
}

export default {
  platform: 'bigcommerce',
  responseHandler,
  sortFields: ['relevance', 'name', 'name:desc', 'price', 'price:desc'],
  SearchRequestDefaults: {
    pageSize: 36,
  },
  product: {
    noImageSrc:
      'https://cdn11.bigcommerce.com/s-fx5ss4ugwz/products/315455/images/660630/H839469DE__31476.1632987199.220.290.jpg',
  },
  Widgets: [
    {
      name: 'SearchPage',
      location: '#cm_results',
      template: 'SearchPage',
    },
    {
      name: 'CategoryPage',
      type: 'SearchPage',
      location: ['category:not(#compare-page)', 'brand']
        .map((className) => `.${className} .page-content`)
        .join(),
      template: 'MainContent',
    },
    {
      name: 'FacetPanel',
    },
    {
      name: 'CategoryFacetPanel',
      type: 'FacetPanel',
      location: 'body:not(.home) .sideCategoryList',
      template: 'FacetPanelContainer',
    },
    {
      name: 'SearchHeader',
    },
    { name: 'SearchResult' },
    {
      name: 'SearchBox',
      location: { replace: '.header .navPages-quickSearch form' },
      template: 'SearchBox',
    },
    {
      name: 'SearchBoxDialogButton',
      location: '.header-container .search.mobile',
      template: 'searchBox/dialogButtonMobile',
    },
    {
      name: 'FacetDialog',
      template: 'FacetDialog',
    },
    {
      name: 'SearchBoxDialog',
      template: 'SearchBoxDialog',
    },
  ],
};
